import { classNames, React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Button } from '@digsup/components-button';
import { styles } from './Footer.scss';

const cx = classNames.bind(styles);

export const Footer = ({
  okTitle,
  cancelTitle,
  onCancel,
  onOk,
  isOkEnabled,
}) => {
  if (!onCancel && !onOk) {
    return null;
  }

  return (
    <div className={cx('c-modal__actions')}>
      {onCancel && (
        <Button
          size="medium"
          onClick={onCancel}
          variant="tertiary"
          className="c-modal__action-button"
          type="button"
          width="auto">
          {cancelTitle}
        </Button>
      )}
      {onOk && (
        <Button
          disabled={!isOkEnabled}
          size="medium"
          onClick={onOk}
          variant="primary"
          className="c-modal__action-button"
          type="submit"
          width="auto">
          {okTitle}
        </Button>
      )}
    </div>
  );
};

Footer.propTypes = {
  okTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  isOkEnabled: PropTypes.bool,
};

Footer.defaultProps = {
  okTitle: 'Ok',
  cancelTitle: 'Cancel',
  isOkEnabled: true,
};
